import AdminTopupsScreen from '../../src/screens/AdminTopupsScreen';

export default function AdminTopupsRoute() {
  return <AdminTopupsScreen />;
}
